import React, { useEffect, useRef, useState } from "react";
import Visadebitcard from "../../assets/images/Visadebitcard.jpg";
import MasterCard from "../../assets/images/master card.jpg";
import AmricanExpress from "../../assets/images/amrican_express.jpg";
import SimpleDialogDemo from "../../components/popup/Success";
import Success from "../../assets/images/success.png";
import Failure from "../../assets/images/failure.png";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { basysPayment, createCustomer } from "../../payment_gateways/basys";
import {
  handlePayment,
  handleSaveCard,
  getTicketForSaveCardCheckout,
  processCheckoutSaveCardReceipt,
  buildMonerisHostedTokenizationIframeSrc,
  getMonerisHostedTokenizationPostMessageTarget,
  getMonerisHostedTokenizationAllowedOrigins,
  chargeMonerisWithHostedTokenDataKey,
} from "../../payment_gateways/moneris";
import { formatDate, storeLog } from "../../utils";
import { CalendarViewMonthSharp } from "@mui/icons-material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var sendrespons = {};

const SaveCardSection = ({
  getCardId,
  vaultTerms,
  isCheck,
  setIsCheck,
  monerisSaveCardOptions,
  formData,
  handleChange,
  errors,
  enableSaveButton,
  setShowCardSaveModal,
  paymentProcessor,
  handleSaveCard,
  accName,
  paynow,
  currencyCode,
  setLoading,
  endpoint,
  guid,
  corpid,
  token,
  groupedInvoices,
  sendrespons,
  createCustomer,
  basysCustomerID,
  basysAccountInfo,
  isBasysTesting,
  basysBillingAddrInfo,
  basysApiToken,
  setCardHasBeenSaved,
  setErrors,
  invoiceItems,
  selectedRows,
  setFailedIsOpen,
  setISOpen,
  data,
  setPaymentFailureReason,
  setIsCardSaveFailedOpen,
  setIsCardSaveOpen,
  checkboxRef,
  itemType,
  displayName,
  isMonerisTesting,
  paymentProcessorName,
  cardHasBeenSaved,
  monerisStoresLinked,
}) => {
  return (
    <>
      <div className="popup_description">
        <h2
          className={`payment-terms-heading ${itemType === 4 ? "payment-terms-heading-margin" : ""
            }`}
        >
          {itemType === 4
            ? `Payment Terms for ${displayName}`
            : "Payment Terms"}
        </h2>
        <p className="payment-terms-text">{vaultTerms}</p>
        <div className="popup_check_terms_condition">
          <input
            ref={checkboxRef}
            type="checkbox"
            name="checkbox"
            id
            checked={isCheck}
            onChange={() => setIsCheck(!isCheck)}
          />
          <span>I accept the above Payment Terms</span>
        </div>
        <hr className="payment-terms-separator" />
      </div>
      <form>
        <div className="card-save-modal-form">
          {monerisSaveCardOptions?.FirstNameSet === "true" && (
            <>
              <label>First Name</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="Enter First Name"
              />
              {errors.first_name && (
                <p className="error">{errors.first_name}</p>
              )}
            </>
          )}

          {monerisSaveCardOptions?.LastNameSet === "true" && (
            <>
              <label>Last Name</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="Enter Last Name"
              />
              {errors.last_name && <p className="error">{errors.last_name}</p>}
            </>
          )}

          {monerisSaveCardOptions?.PhoneNumSet === "true" && (
            <>
              <label>Phone</label>
              <input
                type="phone"
                name="phone"
                maxLength="11"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone"
              />
            </>
          )}
          <div className="card-information-header">
            <hr />
            <p className="card-information-header-text">Card Information</p>
          </div>

          <label>Cardholder Name</label>
          <input
            autocomplete="cc-name"
            type="text"
            name="cardHolderName"
            value={formData.cardHolderName}
            onChange={handleChange}
            placeholder="Enter cardholder Name"
          />
          {errors.cardHolderName && (
            <p className="error">{errors.cardHolderName}</p>
          )}

          <label>Card Number</label>
          <input
            autocomplete="cc-number"
            type="tel"
            name="cardNumber"
            pattern="[\d| ]{16,22}"
            maxLength="19"
            value={formData.cardNumber}
            onChange={handleChange}
            placeholder="0000-0000-0000-0000"
          />
          {errors.cardNumber && <p className="error">{errors.cardNumber}</p>}

          <div className="card-expiry-cvv-container">
            <div className="card_expiry">
              <label>Expiry</label>
              <input
                autocomplete="cc-exp"
                type="tel"
                name="expiry"
                value={formData.expiry}
                onChange={handleChange}
                placeholder="MM/YY"
              />
              {errors.expiry && <p className="error">{errors.expiry}</p>}
            </div>
            <div className="card_cvv">
              <label>CVV</label>
              <input
                autocomplete="cc-csc"
                type="tel"
                name="cvv"
                value={formData.cvv}
                onChange={handleChange}
                placeholder="CVV"
              />
              {errors.cvv && <p className="error">{errors.cvv}</p>}
            </div>
          </div>
          {monerisSaveCardOptions?.BillingAddressSet === "true" && (
            <>
              <div className="card-information-header">
                <hr />
                <p className="card-information-header-text">Billing Address</p>
              </div>
              <label>Address Line 1</label>
              <input
                type="text"
                name="addressLine1"
                value={formData.addressLine1}
                onChange={handleChange}
                placeholder="Address Line 1"
              />
              <label>Address Line 2</label>
              <input
                type="text"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleChange}
                placeholder="Address Line 2"
              />
              <label>City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City"
              />
              <label>Country</label>
              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder="Country"
              />
              <label>Postal Code</label>
              <input
                type="text"
                name="postalCode"
                value={formData.postalCode}
                onChange={handleChange}
                placeholder="Postal Code"
              />
              <label>Province</label>
              <input
                type="text"
                name="province"
                value={formData.province}
                onChange={handleChange}
                placeholder="Province"
              />
            </>
          )}
          <div className="button-pair-container">
            {itemType !== 4 ? (
              <button
                className="cancel-button"
                onClick={() => {
                  setShowCardSaveModal(false);
                  setIsCheck(false);
                }}
              >
                Cancel
              </button>
            ) : <div/>}
            {!cardHasBeenSaved && (
              <button
                className={`save-button ${enableSaveButton() ? "" : "save-card-button-disabled"
                  }`}
                type="submit"
                disabled={!isCheck}
                style={{
                  backgroundColor: enableSaveButton() ? "" : "gray",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  if (paymentProcessor === 0) {
                    handleSaveCard(
                      accName,
                      isMonerisTesting,
                      formData,
                      paynow,
                      currencyCode,
                      setLoading,
                      endpoint,
                      guid,
                      corpid,
                      token,
                      groupedInvoices,
                      sendrespons,
                      monerisSaveCardOptions,
                      setShowCardSaveModal,
                      setIsCardSaveOpen,
                      setIsCardSaveFailedOpen,
                      paymentProcessorName,
                      monerisStoresLinked,
                    );
                  } else {
                    createCustomer(
                      accName,
                      getCardId,
                      false,
                      basysCustomerID,
                      setLoading,
                      basysAccountInfo,
                      isBasysTesting,
                      basysBillingAddrInfo,
                      formData,
                      basysApiToken,
                      sendrespons,
                      endpoint,
                      guid,
                      corpid,
                      token,
                      setShowCardSaveModal,
                      setIsCardSaveOpen,
                      setCardHasBeenSaved,
                      setErrors,
                      invoiceItems,
                      paynow,
                      selectedRows,
                      setFailedIsOpen,
                      setISOpen,
                      data,
                      setPaymentFailureReason,
                      setIsCardSaveFailedOpen,
                      paymentProcessorName,
                    );
                  }
                }}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default function Home() {
  const Opensavecardpopup = () => {
    setShowCardSaveModal(true);
  };

  /**
   * Fetch the GUID and CorpID from the page URL
   */
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const guid = searchParams.get("id");
  const corpid = searchParams.get("corpid");

  /**
   * paymentProcessor determines whether it's moneris or basys
   */
  const [paymentProcessor, setPaymentProcessor] = useState();

  const [imageUrl, setImageUrl] = useState("");
  const [endpoint, setEndpoint] = useState("");
  const [token, setToken] = useState("");
  const [vaultTerms, setVaultTerms] = useState("");
  const [invoiceItems, setInvoiceItems] = useState([]);
  let [isOpen, setISOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, Setdata] = useState();
  const [paynow, SetPaynow] = useState();
  const [itemType, setItemType] = useState(0);
  const [isCardSaveOpen, setIsCardSaveOpen] = useState(false);
  const [accName, setAccName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [groupedInvoices, setGroupedInvoices] = useState([]);
  const [groupedBasysInvoices, setGroupedBasysInvoices] = useState([]);
  const [showCardSaveModal, setShowCardSaveModal] = useState(false);
  const [cardHasBeenSaved, setCardHasBeenSaved] = useState(false);
  const [currencyCode, setCurrencyCode] = useState("");
  const [isCheck, setIsCheck] = useState(false);
  const [basysApiToken, setBasysApiToken] = useState("");
  const [basysAccountInfo, setBasysAccountInfo] = useState({});
  const [failedIsOpen, setFailedIsOpen] = useState(false);
  const [monerisPaymentOptions, setMonerisPaymentOptions] = useState({
    FirstNameSet: "false",
    LastNameSet: "false",
    PhoneNumSet: "false",
    EmailSet: "false",
    BillingAddressSet: "false",
  });
  const [monerisSaveCardOptions, setMonerisSaveCardOptions] = useState({
    FirstNameSet: "true",
    LastNameSet: "true",
    PhoneNumSet: "false",
    EmailSet: "true",
    BillingAddressSet: "false",
  });
  const [isBasysTesting, setIsBasysTesting] = useState(true);
  const [isMonerisTesting, setIsMonerisTesting] = useState(true);
  const [basysBillingAddrInfo, setBasysBillingAddrInfo] = useState({});
  const [paymentFailureReason, setPaymentFailureReason] = useState("");
  const [isCardSaveFailedOpen, setIsCardSaveFailedOpen] = useState(false);
  const [serviceCharge, setServiceCharge] = useState(0.00);
  const [monerisStoresLinked, setMonerisStoresLinked] = useState(false);
  const [showMonerisCheckout, setShowMonerisCheckout] = useState(false);
  const [showMonerisHostedTokenizationPayment, setShowMonerisHostedTokenizationPayment] =
    useState(false);
  const [hostedTokenizationIframeSrc, setHostedTokenizationIframeSrc] = useState("");
  const [isProcessingReceipt, setIsProcessingReceipt] = useState(false);
  const [checkoutTicket, setCheckoutTicket] = useState("");
  const [redirectTimer, setRedirectTimer] = useState(null);
  const [isCheckoutActive, setIsCheckoutActive] = useState(false);
  const [monerisCheckoutInstance, setMonerisCheckoutInstance] = useState(null);
  // Multi-group Moneris Checkout receipt tokenization: progress across sequential iframe sessions
  const [totalTokenizationGroups,  setTotalTokenizationGroups]  = useState(0);
  const [currentTokenizationGroup, setCurrentTokenizationGroup] = useState(0);
  const [isMonerisIframeReady, setIsMonerisIframeReady] = useState(false);
  const [isTokenizeSubmitting, setIsTokenizeSubmitting] = useState(false);

  const basysCustomerID = useRef("");

  const invoicesListForPut = useRef([]);

  const checkboxRef = useRef();
  const paymentProcessorName = useRef();
  const checkoutContextRef = useRef(null); // Store checkout context for receipt processing
  const paymentCompleteHandlerRef = useRef(null);
  // Queue refs for sequential multi-group Checkout receipt tokenization (one MCO session per Moneris store id group)
  const tokenizationQueueRef  = useRef([]);
  const tokenizationIndexRef  = useRef(0);
  /** Snapshot for Hosted Tokenization payment message handler (avoids stale closures) */
  const hostedTokenizationPayContextRef = useRef(null);
  const hostedTokenizationMessageHandledRef = useRef(false);
  const startHostedTokenizationPaymentForGroupRef = useRef(async () => {});

  /**
   * Form data for the input fields
   */
  const [formData, setFormData] = useState({
    amount: "",
    first_name: "",
    last_name: "",
    email: "",
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    country: "",
    postalCode: "",
    province: "",
  });

  /**
   * Converts a Base64-encoded string into an ArrayBuffer.
   *
   * @param {string} base64 - The Base64-encoded string.
   * @returns {ArrayBuffer} The decoded ArrayBuffer.
   */
  const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  };

  /**
   * Decrypts a Base64-encoded, AES-CBC encrypted string using a provided key and IV.
   *
   * @param {string} encrypted - The Base64-encoded encrypted data.
   * @param {string} key - The Base64-encoded decryption key.
   * @param {string} iv - The Base64-encoded initialization vector (IV).
   * @returns {Promise<string>} A promise that resolves to the decrypted plaintext string.
   */
  const decrypt = async (encrypted, key, iv) => {
    const keyBuffer = base64ToArrayBuffer(key);
    const ivBuffer = base64ToArrayBuffer(iv);
    const encryptedData = base64ToArrayBuffer(encrypted);

    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBuffer,
      { name: "AES-CBC", length: 128 },
      false,
      ["decrypt"],
    );

    const decrypted = await window.crypto.subtle.decrypt(
      { name: "AES-CBC", iv: ivBuffer },
      cryptoKey,
      encryptedData,
    );

    return new TextDecoder().decode(new Uint8Array(decrypted));
  };

  /**
   * Fetches the encrypted logo URI and endpoint data from the API, decrypts them, and sets the values.
   *
   * @returns {Promise<void>} A promise that resolves when the logo, endpoint, and token are successfully fetched and decrypted.
   * @throws {Error} Logs a warning if the API call or decryption fails.
   */
  const fetchEndpointAndLogo = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/logo-and-endpoints?corp_id=${corpid}&pg_token=uFHaKqSv25nYnBJ9Epx7kueWRGMa0yo`,
      );
      const { endpoint, logo_uri, custom_factor } = data;

      const key = custom_factor.substring(169, 193);
      const iv = custom_factor.substring(237, 261);

      const imageUrl = await decrypt(logo_uri, key, iv);
      setImageUrl(imageUrl);

      const endpointVal = await decrypt(endpoint.uri, key, iv);
      setEndpoint(endpointVal);
      const token = await decrypt(endpoint.token, key, iv);
      setToken(token);
      console.log("custom_factor", custom_factor);
    } catch (err) {
      console.warn(err);
    }
  };

  useEffect(() => {
    fetchEndpointAndLogo();
  }, []);

  /**
   * Updates the favicon of the page when the `imageUrl` changes.
   *
   * - If a favicon link does not exist, it creates a new `link` element and appends it to the document head.
   * - Sets the favicon image URL dynamically using the `imageUrl` and `corpid`.
   * - Cleans up by removing the `link` element from the document head when the component unmounts.
   *
   * @param {string} imageUrl - The base URL for the favicon image.
   * @param {string} corpid - The CorpID to append to the favicon image URL.
   */
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = `${imageUrl}${corpid}.png`;

    return () => {
      if (link) {
        document.head.removeChild(link);
      }
    };
  }, [imageUrl]);

  /**
   * Handles changes to input fields and applies formatting for specific fields like card number, expiry, and CVV.
   *
   * - Formats credit card number by adding hyphens every 4 digits.
   * - Ensures that expiry dates are in the correct format and prevents invalid months and years.
   * - Limits CVV input to 4 digits.
   *
   * @param {Event} event - The change event from the input field.
   * @returns {void}
   */
  const handleChange = (event) => {
    const { name, value } = event.target;
    let updatedValue = value;

    // Apply formatting for credit card number
    if (name === "cardNumber" && value.length <= 16) {
      // Remove non-digit characters
      updatedValue = value.replace(/\D/g, "");
      // Add hyphens after every 4 digits
      updatedValue = updatedValue.replace(/(\d{4})/g, "$1-");
      // Remove any trailing hyphen
      updatedValue = updatedValue.replace(/-$/, "");
    }

    if (name === "expiry") {
      updatedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      updatedValue = updatedValue.slice(0, 5); // Limit length to 5 characters
      // Ensure month does not exceed 12
      const month = parseInt(updatedValue.slice(0, 2), 10);
      if (month > 12) {
        updatedValue = "12" + updatedValue.slice(2);
      }
      // Ensure year does not exceed 99
      let year = parseInt(updatedValue.slice(2), 10);
      const currentYear = new Date().getFullYear() % 100; // Get last two digits of the current year
      if (year > 99) {
        year = Math.min(year, currentYear + 1); // Limit year to current year or next year
        updatedValue =
          updatedValue.slice(0, 2) + year.toString().padStart(2, "0");
      }
      // Add slash after 2nd character if needed
      if (updatedValue.length > 2 && !updatedValue.includes("/")) {
        updatedValue = updatedValue.slice(0, 2) + "/" + updatedValue.slice(2);
      }
      // Ensure no additional numbers can be entered after the expiry date is complete
      if (updatedValue.length === 5) {
        const [mm, yy] = updatedValue.split("/");
        if (mm.length === 2 && yy.length === 2) {
          updatedValue = mm + "/" + yy;
        }
      }
    }

    // Limit input length for cvv
    if (name === "cvv") {
      updatedValue = value.replace(/\D/g, ""); // Remove non-numeric characters
      if (updatedValue.length > 4) {
        updatedValue = updatedValue.substring(0, 4); // Limit length to 4 digits
      }
    }

    setFormData({ ...formData, [name]: updatedValue });
    setErrors({ ...errors, [name]: "" }); // Clear error when user types
  };

  /**
   * Groups Moneris invoices by Moneris Gateway store id (`MonerisStoreID`).
   *
   * - Each group shares one store; `MonerisAPICredential` is taken from the first row in the bucket
   *   (card + payment checkout IDs and API token from that row).
   * - If the API ever returned multiple checkout profiles under one store id, those rows would merge here;
   *   production data is expected to be one payment/card checkout pair per store (see product sign-off).
   *
   * @param {Array<Object>} invoices - Invoice rows with `MonerisAPICredential`.
   * @returns {Promise<void>}
   */
  const groupByMonerisStoreId = async (invoices) => {
    const grouped = {};

    invoices.forEach((credential, index) => {
      const id = credential.MonerisAPICredential.MonerisStoreID;
      if (!grouped[id]) {
        grouped[id] = [];
      }
      grouped[id].push({
        index,
        ...credential,
      });
    });

    const result = Object.keys(grouped).map((key) => ({
      MonerisAPICredential: grouped[key][0].MonerisAPICredential,
      MonerisProfileID: grouped[key][0].MonerisAPICredential.MonerisProfileID,
      invoices: grouped[key],
    }));

    setGroupedInvoices(result);
  };

  /**
   * Groups an array of invoices by their BasysProcessorID and stores the result.
   *
   * - Groups the invoices by `BasysProcessorID` found in the `BasysAPICredential` object.
   * - Each group is an array of invoices sharing the same BasysProcessorID.
   *
   * @param {Array<Object>} invoices - The array of invoice objects to group.
   * @returns {Promise<void>} A promise that resolves when the grouping is complete and the state is updated.
   */
  const groupByBasysProcessorId = async (invoices) => {
    const grouped = {};

    // Grouping objects by BasysProcessorID
    invoices.forEach((invoiceItem, index) => {
      const id = invoiceItem.BasysProcessorID;
      if (!grouped[id]) {
        grouped[id] = [];
      }
      grouped[id].push({
        index,
        ...invoiceItem,
      });
    });

    setGroupedBasysInvoices(grouped);
  };

  /**
   * Fetches data from the specified endpoint using the provided GUID and corp ID.
   *
   * - Updates various state variables based on the response data, including account details, billing information, payment processor, item types, and invoice items.
   * - Logs the response data and any errors using the `storeLog` function.
   *
   * @returns {Promise<void>} A promise that resolves when the data is fetched and processed, or rejects if an error occurs.
   * @throws {Error} Logs an error and updates the state in case of failure during the fetch process.
   */
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${endpoint}/Get?corpid=${corpid}&id=${guid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
            Origin_Custom: endpoint,
          },
        },
      );

      sendrespons = response.data;

      setAccName(response.data.PayerAccount.AccountName);
      setDisplayName(response.data.PayerAccount.AccountNameDisplay);
      setPaymentProcessor(response.data.PaymentProcessor);
      setMonerisStoresLinked(response?.data?.MonerisStoresLinked === "true");
      const isTesting = response.data.IsTesting;
      if (response.data.PaymentProcessor === 1) {
        paymentProcessorName.current = "basys";
        if (isTesting === "true") {
          setIsBasysTesting(true);
        } else if (isTesting === "false") {
          setIsBasysTesting(false);
        }
      } else if (response.data.PaymentProcessor === 0) {
        paymentProcessorName.current = "moneris";
        if (isTesting === "true") {
          setIsMonerisTesting(true);
        } else if (isTesting === "false") {
          setIsMonerisTesting(false);
        }
      }

      const payerAccount = response.data.PayerAccount;

      setBasysBillingAddrInfo({
        first_name: payerAccount?.AccountFirstName,
        last_name: payerAccount?.AccountLastName,
        company: payerAccount?.AccountName,
        line_1: payerAccount?.Address?.Line1,
        line_2: payerAccount?.Address?.Line2,
        city: payerAccount?.Address?.City,
        state: payerAccount?.Address?.Province,
        postal_code: payerAccount?.Address?.PostalCode ?? "", //Temporory hide not working
        country: payerAccount?.Address.Country ?? "",
        email: payerAccount?.AccountEmail ?? "",
        phone: payerAccount?.PhoneNum ?? "",
        fax: "",
      });

      setCurrencyCode(response.data.CurrencyCode);
      setVaultTerms(response.data.ThePayNowOptions.VaultTermsConditions);
      SetPaynow(response.data.ThePayNowOptions);
      setItemType(response.data.ItemType);
      setMonerisPaymentOptions(response.data.MonerisPaymentCheckoutIDConfig);
      setMonerisSaveCardOptions(
        response.data.MonerisCreditCardCheckoutIDConfig,
      );
      setBasysApiToken(response.data?.BasysAPICredential?.APIToken);
      //      setBasysApiToken("api_2BaAkMlujNSu11icqAUlpBwyb1i");  /*For Production Testing Api Key*/
      basysCustomerID.current = response.data?.BasysCustomerID;
      //setBasysCustomerId(response.data?.BasysCustomerID);
      setBasysAccountInfo(response.data?.PayerAccount);

      // Set the service charge
      if (response?.data?.ServiceChargeRate) {
        setServiceCharge(parseInt(response?.data?.ServiceChargeRate) / 100);
      }

      let selection = [];
      if (response.data.ItemType == 0) {
        response.data.InvoiceItems.forEach((item, index) => {
          if (item.IsDefault === "true" && item.AmountDue !== "0") {
            selection.push(index);
          }
        });
        Setdata(response.data.InvoiceItems);
        setInvoiceItems([...response.data.InvoiceItems]);
        if (response.data.PaymentProcessor === 0) {
          groupByMonerisStoreId(response.data.InvoiceItems);
        } else if (response.data.PaymentProcessor === 1) {
          groupByBasysProcessorId(response.data.InvoiceItems);
        }
      } else if (response.data.ItemType == 1) {
        Setdata(response.data.CiaByWeekItems);
        response.data.CiaByWeekItems.forEach((item, index) => {
          if (item.IsDefault && item.AmountDue !== "0") {
            selection.push(index);
          }
        });
        setInvoiceItems([...response.data.CiaByWeekItems]);
        if (response.data.PaymentProcessor === 0) {
          groupByMonerisStoreId(response.data.CiaByWeekItems);
        } else if (response.data.PaymentProcessor === 1) {
          groupByBasysProcessorId(response.data.CiaByWeekItems);
        }
      } else if (response.data.ItemType == 2) {
        Setdata(response.data.CiaByMonthItems);
        response.data.CiaByMonthItems.forEach((item, index) => {
          if (item.IsDefault && item.AmountDue !== "0") {
            selection.push(index);
          }
        });
        setInvoiceItems([...response.data.CiaByMonthItems]);
        if (response.data.PaymentProcessor === 0) {
          groupByMonerisStoreId(response.data.CiaByMonthItems);
        } else if (response.data.PaymentProcessor === 1) {
          groupByBasysProcessorId(response.data.CiaByMonthItems);
        }
      } else if (response.data.ItemType == 3) {
        Setdata(response.data.CiaPrepayItems);
        response.data.CiaPrepayItems.forEach((item, index) => {
          if (item.IsDefault && item.AmountDue !== "0") {
            selection.push(index);
          }
        });
        setInvoiceItems([...response.data.CiaPrepayItems]);
        if (response.data.PaymentProcessor === 0) {
          groupByMonerisStoreId(response.data.CiaPrepayItems);
        } else if (response.data.PaymentProcessor === 1) {
          groupByBasysProcessorId(response.data.CiaPrepayItems);
        }
      } else {
        if (response.data.ItemType === 4) {
          const grouped = {};

          // Grouping objects by MonerisPaymentChechoutID (save-card credential list; matches pre–Apr 2026 behavior)
          response.data.MonerisApiCredentialList.forEach(
            (credential, index) => {
              const id = credential.MonerisPaymentChechoutID;
              if (!grouped[id]) {
                grouped[id] = [];
              }
              grouped[id].push({
                index,
                ...credential,
              });
            },
          );

          const result = Object.keys(grouped).map((key) => ({
            MonerisAPICredential: grouped[key][0],
          }));

          setGroupedInvoices(result);
        }
        console.warn("itemtype not found!");
      }

      setSelectedRows(selection);

      storeLog(
        "info",
        `${JSON.stringify(response.data)}`,
        response.status,
        guid,
        corpid,
        "GET call",
        `GET call for ${response.data.PayerAccount.AccountName}`,
        "Success",
        paymentProcessorName.current,
      );

      setLoading(false);
    } catch (error) {
      storeLog(
        "error",
        `Error fetching ${endpoint}/Get?corpid=${corpid}&id=${guid}`,
        500,
        guid,
        corpid,
        "GET call",
        `GET call for ${accName}`,
        "Failure",
        paymentProcessorName.current,
      );
      setError(error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token, isCardSaveOpen]);

  // Adjust modal content margin and back button position when payment terms container is visible
  useEffect(() => {
    if (showMonerisCheckout && itemType === 4 && paymentProcessor === 0) {
      const paymentTermsContainer = document.querySelector('.payment-terms-container');
      const modalContent = document.querySelector('.moneris-checkout-modal-content');
      
      if (paymentTermsContainer && modalContent && !isCheck) {
        const containerHeight = paymentTermsContainer.offsetHeight;
        modalContent.style.marginTop = `${75 + containerHeight}px`;
      } else if (modalContent) {
        modalContent.style.marginTop = '75px';
      }
    } else if (showMonerisCheckout && itemType !== 4) {
      // Adjust back button position for payments (not save card)
      const backButton = document.querySelector('.moneris-checkout-back-button');
      if (backButton) {
        backButton.style.top = '85px';
      }
    }
  }, [showMonerisCheckout, itemType, paymentProcessor, isCheck, vaultTerms]);

  // Auto-start Moneris checkout for ItemType 4
  useEffect(() => {
    // Check if Moneris Checkout script is loaded
    const checkScriptLoaded = () => {
      return typeof window.monerisCheckout !== "undefined";
    };

    if (
      itemType === 4 &&
      paymentProcessor === 0 &&
      !loading &&
      groupedInvoices.length > 0 &&
      !isCheckoutActive &&
      !showMonerisCheckout &&
      token &&
      endpoint &&
      accName &&
      checkScriptLoaded()
    ) {
      console.log("Auto-starting Moneris checkout for ItemType 4", {
        itemType,
        paymentProcessor,
        loading,
        groupedInvoicesLength: groupedInvoices.length,
        isCheckoutActive,
        showMonerisCheckout,
        hasToken: !!token,
        hasEndpoint: !!endpoint,
        hasAccName: !!accName,
        scriptLoaded: checkScriptLoaded(),
      });
      initiateMonerisSaveCardCheckout();
    } else if (itemType === 4 && paymentProcessor === 0 && !checkScriptLoaded()) {
      // If script not loaded yet, wait a bit and try again
      const timer = setTimeout(() => {
        if (checkScriptLoaded() && !isCheckoutActive && !showMonerisCheckout) {
          console.log("Moneris script loaded, retrying checkout initialization");
          if (
            !loading &&
            groupedInvoices.length > 0 &&
            token &&
            endpoint &&
            accName
          ) {
            initiateMonerisSaveCardCheckout();
          }
        }
      }, 500);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemType, paymentProcessor, loading, groupedInvoices.length, isCheckoutActive, showMonerisCheckout, token, endpoint, accName]);

  // Start checkout after the div is rendered
  useEffect(() => {
    if (
      monerisCheckoutInstance &&
      checkoutTicket &&
      showMonerisCheckout &&
      isCheckoutActive
    ) {
      // Wait for the div to be rendered
      const timer = setTimeout(() => {
        const checkoutDiv = document.getElementById("monerisCheckout");
        console.log("=== CHECKING FOR CHECKOUT DIV ===");
        console.log("Div found:", !!checkoutDiv);
        console.log("Checkout instance exists:", !!monerisCheckoutInstance);
        console.log("Ticket:", checkoutTicket);
        
        if (checkoutDiv && monerisCheckoutInstance) {
          try {
            console.log("=== STARTING CHECKOUT ===");
            console.log("Calling startCheckout with ticket:", checkoutTicket);
            console.log("Timestamp:", new Date().toISOString());
            monerisCheckoutInstance.startCheckout(checkoutTicket);
            console.log("startCheckout called successfully");
          } catch (error) {
            console.error("=== ERROR STARTING CHECKOUT ===");
            console.error("Error:", error);
            console.error("Error message:", error.message);
            console.error("Error stack:", error.stack);
            setLoading(false);
            setFailedIsOpen(true);
            setPaymentFailureReason("Failed to start Moneris Checkout: " + error.message);
          }
        } else {
          console.warn("=== CHECKOUT DIV NOT READY ===");
          console.warn("Div found:", !!checkoutDiv);
          console.warn("Instance exists:", !!monerisCheckoutInstance);
        }
      }, 200);

      return () => clearTimeout(timer);
    }
  }, [monerisCheckoutInstance, checkoutTicket, showMonerisCheckout, isCheckoutActive]);

  /**
   * Calculates the total amount due based on the selected rows.
   *
   * - Iterates over the `selectedRows` and sums up the amounts.
   * - If an item has an `EditedAmountDue`, it uses that value, otherwise it uses `AmountDue` divided by 100.
   * - Returns the total amount formatted as a USD currency string.
   *
   * @returns {string} The total amount formatted as currency in USD.
   */
  const calculateTotal = () => {
    let total = 0;
    selectedRows.forEach((index) => {
      const currentItem = data[index];
      if (currentItem.hasOwnProperty("EditedAmountDue")) {
        total += parseFloat(currentItem.EditedAmountDue);
      } else {
        total += parseFloat(currentItem.AmountDue / 100);
      }
    });
    return total.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  /**
   * Handles the selection or deselection of a checkbox, updating the `selectedRows` state.
   *
   * - If the `index` is already in `selectedRows`, it removes it.
   * - If the `index` is not in `selectedRows`, it adds it.
   * - Updates the `selectAll` state if all rows are selected.
   *
   * @param {number} index - The index of the checkbox being toggled.
   * @returns {void}
   */
  const handleCheckboxChange = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((item) => item !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
    setSelectAll(selectedRows.length + 1 === data.length);
  };

  /**
   * Toggles the "Select All" checkbox.
   *
   * - If `selectAll` is not active, it selects all rows by setting `selectedRows` to an array of all indices.
   * - If `selectAll` is active, it deselects all rows by clearing `selectedRows`.
   * - Finally, it toggles the `selectAll` state.
   *
   * @returns {void}
   */
  const handleSelectAllChange = () => {
    if (!selectAll) {
      const allIndices = data.map((_, index) => index);
      setSelectedRows(allIndices);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(!selectAll);
  };

  /**
   * Handles changes in the amount input field for each row.
   *
   * - If the row is being edited (`editing` is true) and not already selected, the checkbox for that row is automatically selected.
   * - The entered amount is processed:
   *   - If the amount is valid and less than or equal to the original due amount, it updates the `EditedAmountDue` field and reformats the value for display.
   *   - If the entered amount is less than $0.01, the row is deselected, and the "Select All" checkbox is unchecked.
   *
   * @param {Event} e - The event object from the input change.
   * @param {number} index - The index of the row being edited.
   * @param {boolean} editing - Indicates if the row is in edit mode.
   * @returns {void}
   */
  const handleAmountChange = (e, index, editing) => {
    if (editing && !selectedRows.includes(index)) {
      handleCheckboxChange(index);
    }

    const value = editing
      ? e.target.value
      : parseFloat(e.target.value.replace(",", ""));
    const updatedData = [...data];

    if (!isNaN(value) && value <= data[index].AmountDue / 100) {
      updatedData[index].EditedAmountDue = value;
      const valueToSend = (value * 100).toLocaleString("en-US", {
        minimumFractionDigits: 2,
      });
      updatedData[index].PaymentResponse.PaymentAmount = valueToSend;
      Setdata(updatedData);
    }
    if (value < 0.01) {
      // Deselect the corresponding checkbox
      setSelectedRows(selectedRows.filter((item) => item !== index));
      setSelectAll(false); // Uncheck the "Select All" checkbox
    }
  };

  /**
   * Returns a specific payment date based on the item type.
   *
   * @param {Object} item - The item object containing payment details.
   * @returns {string} - Returns the payment date based on item type.
   *                                If itemType is 1, returns `item.PaymentWeek`.
   *                                If itemType is 2, returns `item.PaymentMonth`.
   *                                If itemType is 3, returns `item.StartDate`.
   *                                If none of the item types match, returns `item.InvoiceDate`.
   */
  function getPaymentDate(item) {
    switch (itemType) {
      case 1:
        return formatDate(item.PaymentWeek);
      case 2:
        return formatDate(item.PaymentMonth);
      case 3:
        return formatDate(item.StartDate);
      default:
        return formatDate(item.InvoiceDate);
    }
  }

  /**
   * Handles the cancel action by closing the modal and redirecting the user to the landing page.
   *
   * - Closes the payment popup by setting `setISOpen` to false.
   * - Redirects the user to the landing page with query parameters for `corpid` and `guid`.
   *
   * @returns {void}
   */
  function handelCancel() {
    setISOpen(false);
    window.location.href = `/?corpid=${corpid}&id=${guid}`;
  }

  /**
   * Retrieves the payment method ID for the current card based on the card number and expiration date.
   *
   * - The card number is cleaned of hyphens and masked for comparison with stored cards.
   * - Sends a request to the vault API to retrieve the customer's stored cards.
   * - Matches the stored card's masked number and expiration date with the provided card details.
   *
   * @returns {Promise<string>} A promise that resolves with the payment method ID if found, or an empty string if no match is found.
   */
  const getCardId = async () => {
    let payment_method_id = "";
    let cardInfo = {};
    const cardNumber = formData.cardNumber.replace(/-/g, "");
    const maskedNumStart = cardNumber.substring(0, 6);
    const maskedNumEnd = cardNumber.slice(-4);
    const expiration_date = formData.expiry;

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/basys/vault-customer/get?action_type=GetCardIdGetCall&pg_token=uFHaKqSv25nYnBJ9Epx7kueWRGMa0yo&customer_id=${basysCustomerID.current}&IsTesting=${isBasysTesting}`,
      {
        headers: {
          Authorization: basysApiToken,
          "Content-Type": "application/json",
        },
      },
    );
    let cards = [];

    if (response?.data?.data?.data?.customer?.payments?.cards) {
      cards = response?.data?.data?.data?.customer?.payments?.cards;
    } else {
      return "";
    }

    for (let i = 0; i < cards.length; i++) {
      const item = cards[i];
      if (
        item.masked_number.substring(0, 6) === maskedNumStart &&
        item.masked_number.slice(-4) === maskedNumEnd &&
        item.expiration_date == expiration_date
      ) {
        payment_method_id = item.id;
        cardInfo = item;
        break;
      }
    }
    return [payment_method_id, cardInfo];
  };

  /**
   * Determines whether the "Save" button should be enabled based on the form data and the payment processor.
   *
   * - If the payment processor is 0, checks that `isCheck` is true and the first name, last name, cardholder name, card number, CVV, and expiry date are provided.
   * - If the payment processor is not 0, checks that `isCheck` is true and the cardholder name, card number, CVV, and expiry date are provided.
   *
   * @returns {boolean} Returns true if the "Save" button should be enabled, false otherwise.
   */
  const enableSaveButton = () => {
    if (paymentProcessor === 0) {
      if (
        isCheck &&
        formData.first_name &&
        formData.last_name &&
        formData.cardHolderName &&
        formData.cardNumber &&
        formData.cvv &&
        formData.expiry
      ) {
        return true;
      }
      return false;
    } else {
      if (
        isCheck &&
        formData.cardHolderName &&
        formData.cardNumber &&
        formData.cvv &&
        formData.expiry
      ) {
        return true;
      }
      return false;
    }
  };

  const getPageTitle = () => {
    if (itemType === 0) {
      return "Payment Portal";
    }
    if (itemType === 4) {
      return "Credit Card Request";
    }
    if (itemType === 1 || itemType === 2 || itemType === 3) {
      return "Contract Payment Request";
    }
    return "";
  };

  useEffect(() => {
    if (showCardSaveModal === true) {
      if (checkboxRef.current && isCheck) {
        checkboxRef.current.checked = true;
      }
    }
  }, [showCardSaveModal]);

  const handleInvoiceRequest = async ({
    StationID,
    InvoiceNum,
    SummaryInvoiceNumber,
  }) => {
    console.log("invoiceNum", InvoiceNum)
    if (InvoiceNum.charAt(0) === "M" || InvoiceNum.charAt(0) === "C") {
      toast.info("Please contact your AE for a copy of this invoice", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    let response = {};
    const payload = { StationID, InvoiceNum, SummaryInvoiceNumber };
    setLoading(true);
    try {
      response = await axios.post(endpoint + "InvRequest", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "*/*",
          Origin_Custom: endpoint,
        },
      });
      storeLog(
        "info",
        `${JSON.stringify(response.data)}`,
        response.status,
        guid,
        corpid,
        "Invoice Request",
        `Invoice Request for ${JSON.stringify(payload)}`,
        "Success",
        paymentProcessorName.current,
      );
      toast.success("You will receive your invoice shortly via email", {
        position: "top-right",
        autoClose: 3000,
      });
    } catch (err) {
      console.warn(err);
      toast.error("Some error occurred while requesting invoice", {
        position: "top-right",
        autoClose: 3000,
      });
      storeLog(
        "error",
        `${JSON.stringify(response.data)}`,
        response?.status,
        guid,
        corpid,
        "Invoice Request",
        `Invoice Request for ${JSON.stringify(payload)}`,
        "Failure",
        paymentProcessorName.current,
      );
    } finally {
      setLoading(false);
    }
  };

  const calculateServiceCharges = () => {
    let total = 0.0;
    selectedRows.forEach((index) => {
      const currentItem = data[index];
      if (currentItem.hasOwnProperty("EditedAmountDue")) {
        const serviceChargeAmount = (parseFloat(currentItem.EditedAmountDue) * serviceCharge).toFixed(2);
        const serviceChargeAmountRounded = parseFloat(serviceChargeAmount) % 1 >= 0.5 ? Math.ceil(parseFloat(serviceChargeAmount)) : Math.floor(parseFloat(serviceChargeAmount));
        total += serviceChargeAmountRounded / 100;
      } else {
        const serviceChargeAmount = (parseFloat(currentItem.AmountDue / 100) * serviceCharge).toFixed(2);
        const serviceChargeAmountRounded = parseFloat(serviceChargeAmount) % 1 >= 0.5 ? Math.ceil(parseFloat(serviceChargeAmount)) : Math.floor(parseFloat(serviceChargeAmount));
        total += serviceChargeAmountRounded / 100;
      }
    });
    return total.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const calculateTotalAmount = () => {
    if (!serviceCharge || serviceCharge === "0") {
      return calculateTotal();
    }
    return (
      parseFloat(calculateTotal().replace(",", "").slice(1)) +
      parseFloat(calculateServiceCharges().replace(",", "").slice(1))
    ).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  const clearMonerisPaymentQueue = () => {
    tokenizationQueueRef.current = [];
    tokenizationIndexRef.current = 0;
    setTotalTokenizationGroups(0);
    setCurrentTokenizationGroup(0);
    hostedTokenizationPayContextRef.current = null;
    setShowMonerisHostedTokenizationPayment(false);
    setHostedTokenizationIframeSrc("");
    hostedTokenizationMessageHandledRef.current = false;
  };

  /**
   * Moneris Hosted Tokenization (HPPtoken): one session per store group — iframe + postMessage('tokenize').
   * @see https://developer.moneris.com/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization
   */
  const startHostedTokenizationPaymentForGroup = async (groupedInvoiceItem) => {
    const cred = groupedInvoiceItem.MonerisAPICredential;
    const profileId = (groupedInvoiceItem.MonerisProfileID || "").trim();
    if (!profileId) {
      toast.error("Hosted Tokenization profile is not configured for this store.", {
        position: "top-right",
        autoClose: 4000,
      });
      throw new Error("Missing Moneris Hosted Tokenization profile id");
    }

    hostedTokenizationPayContextRef.current = {
      isMonerisTesting,
      accName,
      credentials: { store_id: cred.MonerisStoreID, api_token: cred.APIToken },
      invoices: groupedInvoiceItem.invoices,
      allowedOrigins: getMonerisHostedTokenizationAllowedOrigins(isMonerisTesting),
      postMessageTarget: getMonerisHostedTokenizationPostMessageTarget(isMonerisTesting),
      monerisPaymentOptions,
      endpoint,
      guid,
      corpid,
      token,
      selectedRows,
      invoiceItems,
      invoicesListForPut,
      paymentProcessorName: paymentProcessorName.current,
      serviceCharge,
      data,
    };

    setIsMonerisIframeReady(false);
    setIsTokenizeSubmitting(false);
    setHostedTokenizationIframeSrc(
      buildMonerisHostedTokenizationIframeSrc(isMonerisTesting, profileId),
    );
    setShowMonerisHostedTokenizationPayment(true);
    setLoading(false);
  };

  startHostedTokenizationPaymentForGroupRef.current = startHostedTokenizationPaymentForGroup;

  useEffect(() => {
    if (!showMonerisHostedTokenizationPayment) {
      hostedTokenizationMessageHandledRef.current = false;
      return undefined;
    }

    const onMessage = async (event) => {
      const ctx = hostedTokenizationPayContextRef.current;
      if (!ctx) return;
      if (!ctx.allowedOrigins.includes(event.origin)) return;
      if (hostedTokenizationMessageHandledRef.current) return;

      console.log("[MonerisHT] postMessage received from", event.origin, event.data);

      let resp;
      try {
        resp = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch {
        return;
      }
      if (!resp || typeof resp !== "object") return;

      const rc = resp.responseCode;
      const codes = Array.isArray(rc) ? rc.map(String) : [String(rc)];
      console.log("[MonerisHT] responseCode:", codes, "dataKey:", resp.dataKey);
      if (!codes.includes("001")) {
        const errMsg = resp.errorMessage || codes.join(", ") || "Tokenization failed";
        setIsTokenizeSubmitting(false);
        toast.error(String(errMsg), { position: "top-right", autoClose: 5000 });
        return;
      }

      const dataKey = resp.dataKey;
      if (!dataKey) {
        setIsTokenizeSubmitting(false);
        toast.error("No payment token received from Moneris.", { position: "top-right", autoClose: 4000 });
        return;
      }

      hostedTokenizationMessageHandledRef.current = true;
      setIsTokenizeSubmitting(false);
      setShowMonerisHostedTokenizationPayment(false);
      setIsProcessingReceipt(true);
      setLoading(true);

      try {
        await chargeMonerisWithHostedTokenDataKey(
          ctx.isMonerisTesting,
          ctx.accName,
          ctx.credentials,
          dataKey,
          ctx.invoices,
          ctx.monerisPaymentOptions,
          setLoading,
          ctx.endpoint,
          ctx.guid,
          ctx.corpid,
          ctx.token,
          sendrespons,
          ctx.selectedRows,
          ctx.invoiceItems,
          ctx.invoicesListForPut,
          setPaymentFailureReason,
          ctx.paymentProcessorName,
          ctx.serviceCharge,
          ctx.data,
        );

        const nextIndex = tokenizationIndexRef.current + 1;
        const queue = tokenizationQueueRef.current;

        if (nextIndex < queue.length) {
          tokenizationIndexRef.current = nextIndex;
          setCurrentTokenizationGroup(nextIndex + 1);
          setIsProcessingReceipt(false);
          setLoading(false);
          hostedTokenizationMessageHandledRef.current = false;
          setTimeout(() => {
            startHostedTokenizationPaymentForGroupRef.current(queue[nextIndex]).catch((err) => {
              setFailedIsOpen(true);
              setPaymentFailureReason(err.message || "Failed to open next payment");
              clearMonerisPaymentQueue();
            });
          }, 400);
          return;
        }

        setIsProcessingReceipt(false);
        setLoading(false);
        setISOpen(true);
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      } catch (err) {
        setIsProcessingReceipt(false);
        setLoading(false);
        setFailedIsOpen(true);
        setPaymentFailureReason(err.message || "Payment failed");
        clearMonerisPaymentQueue();
      }
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [showMonerisHostedTokenizationPayment]);

  /**
   * Initializes Moneris Checkout with a ticket
   * @param {string} ticket - The checkout ticket
   * @param {Object} context - Checkout context containing credentials, invoices, etc.
   */
  const initializeMonerisCheckout = (ticket, context = null) => {
    // Check if Moneris Checkout is available (loaded from external script)
    const MonerisCheckout = window.monerisCheckout;
    
    if (!MonerisCheckout) {
      console.error("Moneris Checkout script not loaded");
      setLoading(false);
      setFailedIsOpen(true);
      setPaymentFailureReason("Moneris Checkout script not loaded. Please refresh the page.");
      return;
    }

    try {
      const checkout = new MonerisCheckout();
      const mode = isMonerisTesting ? "qa" : "prod";
      checkout.setMode(mode);
      checkout.setCheckoutDiv("monerisCheckout");

      // Track if payment has been handled to avoid double processing
      let paymentHandled = false;
      
      // Create handler function for payment success
      // This is called AFTER PUT call succeeds
      const handlePaymentSuccess = () => {
        console.log("=== HANDLING PAYMENT SUCCESS ===");
        console.log("ItemType:", itemType);
        console.log("Timestamp:", new Date().toISOString());
        
        // Get context to check if this was a save card flow
        const context = checkoutContextRef.current;
        const isSaveCardFlow = context?.isSaveCard || itemType === 4;
        console.log("Is save card flow:", isSaveCardFlow);

        // For save card flow (ItemType 4 or manual save card from footer), don't redirect
        if (isSaveCardFlow) {
          console.log("Save card flow - showing card save success (no redirect)");
          setIsCardSaveOpen(true);
          return;
        }

        // For regular payments, show success and redirect after 5 seconds
        console.log("Regular payment - showing success modal and setting up redirect");
        setISOpen(true);

        // Refresh the page after 5 seconds
        console.log("Setting timeout for page reload in 5 seconds...");
        setTimeout(() => {
          console.log("=== TIMEOUT FIRED: Reloading page now ===");
          console.log("Current URL:", window.location.href);
          window.location.reload();
        }, 5000);
      };

      // Set up callbacks with comprehensive logging
      checkout.setCallback("page_loaded", function(response) {
        console.log("=== MONERIS CALLBACK: page_loaded ===");
        console.log("Response:", JSON.stringify(response, null, 2));
        console.log("Timestamp:", new Date().toISOString());
      });

      checkout.setCallback("cancel_transaction", function(response) {
        console.log("=== MONERIS CALLBACK: cancel_transaction ===");
        console.log("Response:", JSON.stringify(response, null, 2));
        console.log("Timestamp:", new Date().toISOString());
        setShowMonerisCheckout(false);
        setIsCheckoutActive(false);
        setLoading(false);
        if (!checkoutContextRef.current?.isSaveCard) {
          clearMonerisPaymentQueue();
        }
      });

      checkout.setCallback("error_event", function(response) {
        console.log("=== MONERIS CALLBACK: error_event ===");
        console.log("Response:", JSON.stringify(response, null, 2));
        console.log("Timestamp:", new Date().toISOString());
        setShowMonerisCheckout(false);
        setIsCheckoutActive(false);
        setLoading(false);
        setFailedIsOpen(true);
        setPaymentFailureReason(response.error_message || JSON.stringify(response));
        clearMonerisPaymentQueue();
      });

      checkout.setCallback("payment_receipt", async function(response) {
        console.log("=== MONERIS CALLBACK: payment_receipt ===");
        console.log("Response:", JSON.stringify(response, null, 2));
        console.log("Timestamp:", new Date().toISOString());
        
        if (paymentHandled) {
          console.log("Payment already being processed, ignoring duplicate receipt");
          return;
        }
        
        // Parse response to extract ticket
        let parsedResponse = response;
        if (typeof response === 'string') {
          try {
            parsedResponse = JSON.parse(response);
          } catch (e) {
            console.log("Could not parse response as JSON:", e);
            return;
          }
        }
        
        const receiptTicket = parsedResponse?.ticket;
        if (!receiptTicket) {
          console.error("No ticket found in payment_receipt response");
          return;
        }
        
        console.log("Extracted ticket from payment_receipt:", receiptTicket);
        
        // Get checkout context
        const context = checkoutContextRef.current;
        console.log("=== PAYMENT RECEIPT CALLBACK ===");
        console.log("Context:", context);
        console.log("Context.isSaveCard:", context?.isSaveCard);
        console.log("itemType:", itemType);
        
        // IMMEDIATELY hide checkout modal and show processing loader
        setShowMonerisCheckout(false);
        setIsCheckoutActive(false);
        setIsProcessingReceipt(true);
        
        if (!context) {
          console.error("No checkout context found");
          setIsProcessingReceipt(false);
          setLoading(false);
          setFailedIsOpen(true);
          setPaymentFailureReason("Checkout context not found");
          return;
        }
        
        // Process receipt and make PUT call
        try {
          setLoading(true);

          const isSaveCardFlow = context.isSaveCard || itemType === 4;

          if (!isSaveCardFlow) {
            throw new Error("Unexpected Moneris Checkout session: only save-card uses hosted checkout.");
          }

          await processCheckoutSaveCardReceipt(
            accName,
            isMonerisTesting,
            context.credentials,
            receiptTicket,
            formData,
            endpoint,
            guid,
            corpid,
            token,
            sendrespons,
            context.monerisSaveCardOptions || monerisSaveCardOptions,
            paymentProcessorName.current,
          );

          console.log("PUT call completed successfully - showing success");
          setIsProcessingReceipt(false);
          setLoading(false);
          paymentHandled = true;
          handlePaymentSuccess();
        } catch (error) {
          console.error("Error processing receipt:", error);
          // Hide loader and show error (checkout already hidden at start of receipt callback)
          setIsProcessingReceipt(false);
          setLoading(false);
          setFailedIsOpen(true);
          setPaymentFailureReason(error.message || "Failed to process payment");
        }
      });

      checkout.setCallback("payment_complete", function(response) {
        console.log("=== MONERIS CALLBACK: payment_complete ===");
        console.log("Response:", JSON.stringify(response, null, 2));
        console.log("Response type:", typeof response);
        console.log("Response keys:", response ? Object.keys(response) : "null");
        console.log("Has error_message:", response?.error_message);
        console.log("Has card_data_key:", response?.card_data_key);
        console.log("Timestamp:", new Date().toISOString());
        
        // payment_receipt should have already handled the processing
        // This callback is just for logging/backup
        if (paymentHandled) {
          console.log("Payment already processed via payment_receipt, ignoring payment_complete");
          return;
        }
        
        if (response && response.error_message) {
          console.log("ERROR: Payment failed with error:", response.error_message);
          setShowMonerisCheckout(false);
          setIsCheckoutActive(false);
          setFailedIsOpen(true);
          setPaymentFailureReason(response.error_message);
          return;
        }

        // If payment_receipt didn't fire, this is a backup (shouldn't happen normally)
        console.log("payment_complete fired but payment_receipt didn't process - this is unexpected");
      });

      console.log("=== CHECKOUT INITIALIZED ===");
      console.log("Ticket:", ticket);
      console.log("Mode:", isMonerisTesting ? "qa" : "prod");
      console.log("Checkout div ID: monerisCheckout");
      
      console.log("=== CHECKOUT INITIALIZED ===");
      console.log("Ticket:", ticket);
      console.log("Mode:", isMonerisTesting ? "qa" : "prod");
      console.log("Checkout div ID: monerisCheckout");
      
      // Store checkout context for receipt processing
      if (context) {
        checkoutContextRef.current = context;
        console.log("Checkout context stored:", context);
      } else {
        console.warn("No context provided to initializeMonerisCheckout");
      }
      
      setMonerisCheckoutInstance(checkout);
      setCheckoutTicket(ticket);
      setIsCheckoutActive(true);
      setShowMonerisCheckout(true);
      setLoading(false);
      
      console.log("State updated - checkout should be visible now");
      
      console.log("State updated - checkout should be visible now");
    } catch (error) {
      console.error("Error initializing Moneris Checkout:", error);
      setLoading(false);
      setFailedIsOpen(true);
      setPaymentFailureReason("Failed to initialize Moneris Checkout");
    }
  };

  /**
   * Handles Moneris payment completion
   */
  const handleMonerisPaymentComplete = (response) => {
    if (response.error_message) {
      setShowMonerisCheckout(false);
      setIsCheckoutActive(false);
      setFailedIsOpen(true);
      setPaymentFailureReason(response.error_message);
      return;
    }

    // For ItemType 4, don't redirect
    if (itemType === 4) {
      setShowMonerisCheckout(false);
      setIsCheckoutActive(false);
      setIsCardSaveOpen(true);
      return;
    }

    // For regular payments, redirect after 5 seconds
    setShowMonerisCheckout(false);
    setIsCheckoutActive(false);
    setISOpen(true);

    // Redirect after 5 seconds without showing timer
    setTimeout(() => {
      window.location.href = `/?corpid=${corpid}&id=${guid}`;
    }, 5000);
  };

  /**
   * Default Moneris payment: Moneris Hosted Tokenization (HPPtoken) + `/moneris/vault` tokenized_purchase,
   * one iframe session per Moneris store group (sequential queue).
   */
  const initiateTokenizationPaymentFlow = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one invoice to pay", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    // Build queue of groups that actually have selected invoices
    const queue = groupedInvoices.filter(group =>
      group.invoices.some(inv => selectedRows.includes(inv.index))
    );

    if (queue.length === 0) {
      toast.error("No valid invoice groups found", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    setLoading(true);
    tokenizationQueueRef.current = queue;
    tokenizationIndexRef.current = 0;
    setTotalTokenizationGroups(queue.length);
    setCurrentTokenizationGroup(1);

    try {
      await startHostedTokenizationPaymentForGroup(queue[0]);
    } catch (error) {
      console.error("Error starting tokenization flow:", error);
      setLoading(false);
      setFailedIsOpen(true);
      setPaymentFailureReason(error.message || "Failed to initiate payment");
      clearMonerisPaymentQueue();
    }
  };

  /**
   * Initiates Moneris Checkout for save card (ItemType 4)
   */
  const initiateMonerisSaveCardCheckout = async () => {
    // Reset checkbox to unchecked when starting checkout for ItemType 4
    setIsCheck(false);
    setLoading(true);

    try {
      // Use the first grouped invoice for checkout
      const groupedInvoiceItem = groupedInvoices[0];
      if (!groupedInvoiceItem) {
        throw new Error("No invoice group found");
      }

      // For ItemType 4, MonerisAPICredential is directly on the item
      const credential = groupedInvoiceItem.MonerisAPICredential || groupedInvoiceItem;
      
      const credentials = {
        store_id: credential.MonerisStoreID,
        api_token: credential.APIToken,
        checkout_id: credential.MonerisCardChechoutID,
      };

      const ticket = await getTicketForSaveCardCheckout(
        accName,
        isMonerisTesting,
        credentials,
        corpid,
        guid,
      );

      // Store checkout context for receipt processing (ItemType 4)
      const checkoutContext = {
        credentials,
        invoices: [], // ItemType 4 doesn't have invoices
        groupedInvoiceItem: groupedInvoiceItem,
        monerisSaveCardOptions: monerisSaveCardOptions, // Include save card options
        isSaveCard: true, // Flag to indicate this is a save card flow
      };

      initializeMonerisCheckout(ticket, checkoutContext);
    } catch (error) {
      console.error("Error initiating Moneris Save Card Checkout:", error);
      setLoading(false);
      setFailedIsOpen(true);
      setPaymentFailureReason(error.message || "Failed to initiate save card");
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="dashboard">
        {/* Dashboard head Start */}
        <div className="dashboard_head">
          <div className="header-logo-container">
            <div className="logo">
              <img
                src={`${imageUrl}${corpid}.png`}
                alt="logo"
                style={{ width: "70px", marginTop: "2.5px" }} // Adjust the width and height as needed
              />
            </div>
            <div className="header-title-text">{`${paynow?.Title
              } ${getPageTitle()}`}</div>
          </div>
          <div className="contect">
            {paynow && paynow.ShowTopBanner && (
              <p>Need Help? {paynow.HelpCenterPhone}</p>
            )}
          </div>
        </div>
        {/* Dashboard head end */}

        {/* Dashbord Body start */}
        <div className="dashboard_body">
          {/* Normal content always renders */}
              <div className={`paymemt_history ${paymentProcessor === 0 && itemType !== 4 ? "paymemt_history-full-width" : ""}`}>
            <div className="paymemt_history_heading">
              <div className="header-text-container">
                <div className="title-desc-container">
                  <div>
                    <p
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#000000",
                        marginBottom: "0.25rem",
                      }}
                    >{`${itemType === 0 ? "Invoice" : "Payment"} Details${displayName ? " for " + displayName : ""
                      }`}</p>
                  </div>
                  <div>
                    {paynow && paynow.ShowInvDetailsDescription ? (
                      <p>{paynow.InvDetailsDescription}</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="subtotale">
                  {serviceCharge ? (
                    <>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#000000",
                        }}
                      >
                        {`Payment: ${calculateTotal()}`}
                      </label>
                      <label
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#000000",
                          marginTop: "0.1rem",
                          marginBottom: "0.1rem",
                        }}
                      >
                        {`Service Fee: ${calculateServiceCharges()}`}
                      </label>
                    </>
                  ) : null}
                  <strong>
                    {" "}
                    <label
                      style={{
                        fontSize: serviceCharge ? "16px" : "18px",
                        fontWeight: "bold",
                        color: "#000000",
                      }}
                    >
                      Total:{" "}
                    </label>
                    <span
                      style={{
                        fontSize: serviceCharge ? "16px" : "18px",
                        fontWeight: "bold",
                        color: "#000000",
                      }}
                    >
                      {(selectedRows.length > 0 && (
                        <span>{calculateTotalAmount()}</span>
                      )) ||
                        "$0.00"}
                    </span>
                  </strong>
                </div>
              </div>
            </div>

            <SimpleDialogDemo
              open={isOpen}
              handelCancel={handelCancel}
              ButtonText={"OK"}
              image={Success}
              alt={"successlogo"}
              title={"Payment Processed"}
              decs={
                "You will receive an email confirmation of your payment(s) shortly. If you don't receive it, please check your Junk folder."
              }
              ButtonHandel={handelCancel}
              color={"#048547"}
            />

            <SimpleDialogDemo
              open={failedIsOpen}
              handelCancel={() => setFailedIsOpen(false)}
              ButtonText={"OK"}
              image={Failure}
              alt={"errorLogo"}
              title={"Payment Failed"}
              decs={paymentFailureReason}
              ButtonHandel={() => {
                setPaymentFailureReason("");
                setFailedIsOpen(false);
              }}
              color={"#048547"}
            />

            <SimpleDialogDemo
              open={isCardSaveOpen}
              handelCancel={() => setIsCardSaveOpen(false)}
              ButtonText={"OK"}
              image={Success}
              alt={"save details"}
              title={"Card Saved"}
              decs={
                "Your card details have been saved.<br/>Future invoices will be processed automatically"
              }
              ButtonHandel={() => {
                setIsCardSaveOpen(false);
                setCardHasBeenSaved(true);
                // Clear form data
                setFormData({
                  amount: "",
                  first_name: "",
                  last_name: "",
                  email: "",
                  cardHolderName: "",
                  cardNumber: "",
                  expiry: "",
                  cvv: "",
                  phone: "",
                  addressLine1: "",
                  addressLine2: "",
                  city: "",
                  country: "",
                  postalCode: "",
                  province: "",
                });
                setIsCheck(false);
              }}
              color={"#2D4691"}
              zIndex={100004}
              className="save-card-success-dialog"
            />

            <SimpleDialogDemo
              open={isCardSaveFailedOpen}
              handelCancel={() => {
                setPaymentFailureReason("");
                setIsCardSaveFailedOpen(false);
              }}
              ButtonText={"OK"}
              image={Failure}
              alt={"save details"}
              title={"Failed to save card"}
              decs={paymentFailureReason}
              ButtonHandel={() => {
                setIsCardSaveFailedOpen(false);
              }}
              color={"#2D4691"}
              zIndex={100004}
              className="save-card-failure-dialog"
            />

            {!showMonerisCheckout ? (
              <>
            <div className="payment_history_table">
              <table>
                {/* table heading start */}
                <tbody>
                  <tr id="invoice-table-header">
                    {itemType === 0 ? (
                      <th>
                        {" "}
                        <button onClick={handleSelectAllChange}>
                          {selectAll ? "Deselect All" : "Select All"}
                        </button>
                      </th>
                    ) : null}
                    <th>Station</th>
                    <th>Contract</th>
                    {itemType === 0 ? <th>Invoice</th> : null}
                    <th>{itemType === 0 ? "Invoice Date" : "Date"}</th>
                    <th className="textright amout_width">
                      {itemType === 0 ? "Invoice Amount" : "Amount Due Today"}
                    </th>
                    {itemType === 0 ? (
                      <th className="textright">Balance</th>
                    ) : null}
                    <th>{itemType === 0 ? "Amount To Pay" : "Paying"}</th>
                  </tr>
                  {loading && (
                    <div className="modal-overlay bg-white">
                      <div className="api-loading-container">
                        <div id="loader"></div>
                        <p className="loading-text">Loading...</p>
                      </div>
                    </div>
                  )}
                  <div className="loader-container">
                    {!loading && !data && (
                      <p>Data Not Found. Please contact the admin.</p>
                    )}
                  </div>
                  {data &&
                    data.map((item, i) => {
                      return (
                        <tr key={i}>
                          {itemType === 0 ? (
                            <td>
                              <input
                                type="checkbox"
                                onChange={() => handleCheckboxChange(i)}
                                checked={selectedRows.includes(i)}
                                style={{
                                  opacity:
                                    item.AmountDue === "0" ||
                                      parseFloat(item?.EditedAmountDue) < 0.01
                                      ? 0.5
                                      : 1,
                                  pointerEvents:
                                    item.AmountDue === "0" ||
                                      parseFloat(item?.EditedAmountDue) < 0.01
                                      ? "none"
                                      : "auto",
                                  cursor:
                                    item.AmountDue === "0" ||
                                      parseFloat(item?.EditedAmountDue) < 0.01
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                              />
                            </td>
                          ) : null}
                          <td>
                            {(item.SummaryInvoiceNumber > 0 && "Multi") ||
                              item.StationName}
                          </td>
                          <td>
                            {(item.SummaryInvoiceNumber > 0 && "Multi") ||
                              item.ContractNumber}
                          </td>
                          {itemType === 0 ? (
                            <td
                              className={`invoice-number-text ${(item.InvoiceNum.charAt(0) !== "M" && item.InvoiceNum.charAt(0) !== "C") ? "invoice-number-text-underline" : ""}`}
                              onClick={() =>
                                handleInvoiceRequest({
                                  StationID: item.StationID,
                                  InvoiceNum: item.InvoiceNum,
                                  SummaryInvoiceNumber:
                                    item.SummaryInvoiceNumber,
                                })
                              }
                              title="Click to receive copy of invoice via email"
                            >
                              {(item.SummaryInvoiceNumber > 0 &&
                                item.SummaryInvoiceNumber) ||
                                (item.SummaryInvoiceNumber === "0" &&
                                  item.InvoiceNum)}
                            </td>
                          ) : null}
                          <td>{getPaymentDate(item)}</td>
                          {itemType === 0 ? (
                            <td className="textright">
                              {(item.InvoiceAmount / 100).toLocaleString(
                                "en-US",
                                { style: "currency", currency: "USD" },
                              )}
                            </td>
                          ) : null}
                          <td className="textright">
                            {(item.AmountDue / 100).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </td>
                          <td className="dollar">
                            <div>
                              $
                              <input
                                className="editamount textright"
                                type="text" // Change type to text to display formatted value correctly
                                style={{
                                  opacity: item.AmountDue === "0" ? 0.5 : 1,
                                  pointerEvents:
                                    item.AmountDue === "0" ? "none" : "auto",
                                  cursor:
                                    item.AmountDue === "0"
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onBlur={(e) => {
                                  handleAmountChange(e, i, false);
                                }}
                                value={
                                  item.EditedAmountDue !== undefined
                                    ? item.EditedAmountDue.toLocaleString(
                                      "en-US",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    )
                                    : (itemType === 0
                                      ? item.AmountDue / 100
                                      : 0
                                    ).toLocaleString("en-US", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })
                                }
                                onChange={(e) => handleAmountChange(e, i, true)}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}

                  {/* table Discription End */}
                </tbody>
              </table>
            </div>

            <div className="payment_information_accounting_office">
              {paynow && paynow.ShowBottomBanner && (
                <div>
                  <h2>{paynow.Title}</h2>
                  <p>
                    Phone:{" "}
                    <a
                      style={{
                        color: "var(--font-gray-color)",
                        textDecoration: "none",
                      }}
                      href="tel:+1-416-987-3456"
                    >
                      {paynow.Phone}
                    </a>
                  </p>
                  <p>
                    Email:{" "}
                    <a
                      style={{
                        color: "var(--font-gray-color)",
                        textDecoration: "none",
                      }}
                      href={"mailto:" + paynow.Email}
                    >
                      {paynow.Email}
                    </a>
                  </p>
                  <p>
                    Address: {paynow.Address} {paynow.City}, {paynow.Prov},{" "}
                    {paynow.Postal}
                  </p>
                </div>
              )}
              {!cardHasBeenSaved && (
                <div className="card_vault">
                  <div>
                    <button
                      style={{
                        fontSize: "16px",
                        width: "10rem",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        // For Moneris, trigger save card checkout flow
                        if (paymentProcessor === 0) {
                          initiateMonerisSaveCardCheckout();
                        } else {
                          // For Basys, use the existing popup
                          Opensavecardpopup();
                        }
                      }}
                    >
                      Store card
                    </button>
                  </div>
                  <p>
                    Securely store your credit card, for automatic <br />
                    monthly payments of future invoices
                  </p>
                </div>
              )}
            </div>
              </>
            ) : null}
          </div>
          {/* card details */}

          <div className="payment_information">
            {paymentProcessor !== 0 || itemType === 4 ? (
            <>
            <div className="payment_information_heading">
              <div className="payment_information_heading_details">
                <p style={{ fontSize: "24px", fontWeight: "bold" }}>
                  Payment Information
                </p>
                <div className="paymemt_card">
                  <img src={Visadebitcard} alt="Visadebitcard" />
                  <img src={MasterCard} alt="MasterCard" />
                  <img src={AmricanExpress} alt="AmricanExpress" />
                </div>
              </div>
            </div>
            <form>
              <div className="formdetails" id="formdetails">
                {monerisPaymentOptions?.FirstNameSet === "true" && (
                  <>
                    <label>First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      placeholder="Enter First Name"
                    />
                    {errors.first_name && (
                      <p className="error">{errors.first_name}</p>
                    )}
                  </>
                )}
                {monerisPaymentOptions?.LastNameSet === "true" && (
                  <>
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      placeholder="Enter Last Name"
                    />
                    {errors.last_name && (
                      <p className="error">{errors.last_name}</p>
                    )}
                  </>
                )}

                {monerisPaymentOptions?.PhoneNumSet === "true" && (
                  <>
                    <label>Phone</label>
                    <input
                      type="phone"
                      name="phone"
                      maxLength="11"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone"
                    />
                  </>
                )}
                <div className="card_info_tag">
                  <hr />
                  <p>Card Information</p>
                </div>

                <label>Cardholder Name</label>
                <input
                  autocomplete="cc-name"
                  type="text"
                  name="cardHolderName"
                  value={formData.cardHolderName}
                  onChange={handleChange}
                  placeholder="Enter cardholder Name"
                />
                {!showCardSaveModal && errors.cardHolderName && (
                  <p className="error">{errors.cardHolderName}</p>
                )}

                <label>Card Number</label>
                <input
                  autocomplete="cc-number"
                  type="tel"
                  name="cardNumber"
                  pattern="[\d| ]{16,22}"
                  maxLength="19"
                  value={formData.cardNumber}
                  onChange={handleChange}
                  placeholder="0000-0000-0000-0000"
                />
                {!showCardSaveModal && errors.cardNumber && (
                  <p className="error">{errors.cardNumber}</p>
                )}

                <div className="card_cvv_expiry">
                  <div className="card_expiry">
                    <label>Expiry</label>
                    <input
                      autocomplete="cc-exp"
                      type="tel"
                      name="expiry"
                      value={formData.expiry}
                      onChange={handleChange}
                      placeholder="MM/YY"
                    />
                    {!showCardSaveModal && errors.expiry && (
                      <p className="error">{errors.expiry}</p>
                    )}
                  </div>
                  <div className="card_cvv">
                    <label>CVV</label>
                    <input
                      autocomplete="cc-csc"
                      type="tel"
                      name="cvv"
                      value={formData.cvv}
                      onChange={handleChange}
                      placeholder="CVV"
                    />
                    {!showCardSaveModal && errors.cvv && (
                      <p className="error">{errors.cvv}</p>
                    )}
                  </div>
                </div>
                {monerisPaymentOptions?.BillingAddressSet === "true" && (
                  <>
                    <div className="card-information-header">
                      <hr />
                      <p className="card-information-header-text">
                        Billing Address
                      </p>
                    </div>
                    <label>Address Line 1</label>
                    <input
                      type="text"
                      name="addressLine1"
                      value={formData.addressLine1}
                      onChange={handleChange}
                      placeholder="Address Line 1"
                    />
                    <label>Address Line 2</label>
                    <input
                      type="text"
                      name="addressLine2"
                      value={formData.addressLine2}
                      onChange={handleChange}
                      placeholder="Address Line 2"
                    />
                    <label>City</label>
                    <input
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="City"
                    />
                    <label>Country</label>
                    <input
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      placeholder="Country"
                    />
                    <label>Postal Code</label>
                    <input
                      type="text"
                      name="postalCode"
                      value={formData.postalCode}
                      onChange={handleChange}
                      placeholder="Postal Code"
                    />
                    <label>Province</label>
                    <input
                      type="text"
                      name="province"
                      value={formData.province}
                      onChange={handleChange}
                      placeholder="Province"
                    />
                  </>
                )}
                <button
                  className={
                    !selectedRows?.length ||
                      !formData.cardHolderName ||
                      !formData.cardNumber ||
                      !formData.cvv ||
                      !formData.expiry || loading
                      ? "save-card-button-disabled"
                      : ""
                  }
                  type="submit"
                  onClick={(e) => {
                    (paymentProcessor === 0 &&
                      handlePayment(
                        e,
                        isMonerisTesting,
                        accName,
                        formData,
                        paynow,
                        currencyCode,
                        monerisPaymentOptions,
                        setLoading,
                        endpoint,
                        guid,
                        corpid,
                        token,
                        groupedInvoices,
                        setFailedIsOpen,
                        setISOpen,
                        selectedRows,
                        sendrespons,
                        invoiceItems,
                        invoicesListForPut,
                        data,
                        setErrors,
                        setPaymentFailureReason,
                        paymentProcessorName.current,
                        serviceCharge,
                      )) ||
                      basysPayment(
                        e,
                        accName,
                        getCardId,
                        basysCustomerID,
                        setLoading,
                        invoiceItems,
                        basysAccountInfo,
                        paynow,
                        isBasysTesting,
                        basysBillingAddrInfo,
                        formData,
                        basysApiToken,
                        selectedRows,
                        sendrespons,
                        endpoint,
                        guid,
                        corpid,
                        token,
                        setFailedIsOpen,
                        setISOpen,
                        data,
                        setShowCardSaveModal,
                        setIsCardSaveOpen,
                        setCardHasBeenSaved,
                        setErrors,
                        setPaymentFailureReason,
                        setIsCardSaveFailedOpen,
                        paymentProcessorName.current,
                        serviceCharge,
                        groupedBasysInvoices,
                      );
                  }}
                >
                  Process Payment
                </button>
              </div>
            </form>
            </>
            ) : (
              // For Moneris checkout flow, show only the button without form
              <>
                <div className="moneris-checkout-info-text">
                  <p>
                    Select the invoices you wish to pay and click Proceed to Checkout button below.
                  </p>
                </div>
                <div className="moneris-checkout-button-container">
                  <button
                    className={
                      !selectedRows?.length || loading
                        ? "save-card-button-disabled"
                        : ""
                    }
                    type="button"
                    onClick={() => {
                      void initiateTokenizationPaymentFlow();
                    }}
                    disabled={!selectedRows?.length || loading}
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Dashbard Body End */}

        {/* Full-screen Moneris Checkout Modal - Renders as overlay OUTSIDE dashboard */}
        {showMonerisCheckout && (
          <div className="moneris-checkout-modal-overlay">
            {/* Modal Header - same as main header */}
            <div className="moneris-checkout-modal-header">
              <div className="header-logo-container">
                <div className="logo">
                  <img
                    src={`${imageUrl}${corpid}.png`}
                    alt="logo"
                    style={{ width: "70px", marginTop: "2.5px" }}
                  />
                </div>
                <div className="header-title-text">{`${paynow?.Title} ${getPageTitle()}`}</div>
                {totalTokenizationGroups > 1 && (
                  <div style={{ fontSize: "13px", color: "var(--font-white-color)", marginTop: "4px" }}>
                    Processing payment {currentTokenizationGroup} of {totalTokenizationGroups}
                  </div>
                )}
              </div>
              <div className="contect">
                {paynow && paynow.ShowBottomBanner && (
                  <div style={{ textAlign: "right" }}>
                  <p style={{ margin: "0", fontSize: "14px" }}>
                    {paynow.Address} {paynow.City}, {paynow.Prov}, {paynow.Postal}
                  </p>
                    <p style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
                      Phone:{" "}
                      <a
                        style={{
                          color: "var(--font-white-color)",
                          textDecoration: "none",
                        }}
                        href="tel:+1-416-987-3456"
                      >
                        {paynow.Phone}
                      </a>
                    </p>
                    <p style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
                      Email:{" "}
                      <a
                        style={{
                          color: "var(--font-white-color)",
                          textDecoration: "none",
                        }}
                        href={"mailto:" + paynow.Email}
                      >
                        {paynow.Email}
                      </a>
                    </p>
                  </div>
                )}
              </div>
            </div>
            
            {/* Floating Back Button - Only show for payments, not save card */}
            {itemType !== 4 && (
              <button
                className="moneris-checkout-back-button"
                onClick={() => {
                  // Clear iframe content
                  const checkoutDiv = document.getElementById("monerisCheckout");
                  if (checkoutDiv) {
                    const iframe = checkoutDiv.querySelector('iframe');
                    if (iframe) {
                      iframe.src = 'about:blank';
                    }
                    checkoutDiv.innerHTML = '';
                  }
                  setShowMonerisCheckout(false);
                  setIsCheckoutActive(false);
                  setMonerisCheckoutInstance(null);
                  setCheckoutTicket(null);
                  setLoading(false);
                  if (!checkoutContextRef.current?.isSaveCard) {
                    clearMonerisPaymentQueue();
                  }
                }}
                aria-label="Go back"
              >
                &laquo; Back
              </button>
            )}

            {/* Payment Summary - Top right, symmetric to back button */}
            {itemType !== 4 && (
              <div className="moneris-payment-summary">
                {serviceCharge ? (
                  <>
                    <div style={{ fontSize: "16px", fontWeight: "bold", color: "#000000" }}>
                      {`Payment: ${calculateTotal()}`}
                    </div>
                    <div style={{ fontSize: "16px", fontWeight: "bold", color: "#000000", marginTop: "0.1rem", marginBottom: "0.1rem" }}>
                      {`Service Fee: ${calculateServiceCharges()}`}
                    </div>
                  </>
                ) : null}
                <div style={{ fontSize: serviceCharge ? "16px" : "18px", fontWeight: "bold", color: "#000000" }}>
                  {`Total: ${selectedRows.length > 0 ? calculateTotalAmount() : "$0.00"}`}
                </div>
              </div>
            )}

            {/* Payment Terms Container for ItemType 4 - Below header */}
            {itemType === 4 && paymentProcessor === 0 && !isCheck && (
              <div className="payment-terms-container">
                <div className="payment-terms-content">
                  <h2 className="payment-terms-heading payment-terms-heading-margin">
                    Payment Terms for {displayName}
                  </h2>
                  <p className="payment-terms-text">{vaultTerms}</p>
                  <div className="popup_check_terms_condition">
                    <input
                      ref={checkboxRef}
                      type="checkbox"
                      name="checkbox"
                      id="checkout-terms-checkbox"
                      checked={isCheck}
                      onChange={() => setIsCheck(!isCheck)}
                    />
                    <span>I accept the above Payment Terms</span>
                  </div>
                </div>
              </div>
            )}
            
            {/* Modal Content - Checkout iframe */}
            <div className="moneris-checkout-modal-content">
              <div className="moneris-checkout-container">
                <div id="monerisCheckout"></div>
                {/* Overlay to block iframe interaction when checkbox is unchecked for ItemType 4 */}
                {itemType === 4 && paymentProcessor === 0 && !isCheck && (
                  <div 
                    className="moneris-checkout-blocking-overlay"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {showMonerisHostedTokenizationPayment && (
          <div className="moneris-checkout-modal-overlay">
            <div className="moneris-checkout-modal-header">
              <div className="header-logo-container">
                <div className="logo">
                  <img
                    src={`${imageUrl}${corpid}.png`}
                    alt="logo"
                    style={{ width: "70px", marginTop: "2.5px" }}
                  />
                </div>
                <div className="header-title-text">{`${paynow?.Title} ${getPageTitle()}`}</div>
              </div>
              <div className="contect">
                {paynow && paynow.ShowBottomBanner && (
                  <div style={{ textAlign: "right" }}>
                    <p style={{ margin: "0", fontSize: "14px" }}>
                      {paynow.Address} {paynow.City}, {paynow.Prov}, {paynow.Postal}
                    </p>
                    <p style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
                      Phone:{" "}
                      <a
                        style={{ color: "var(--font-white-color)", textDecoration: "none" }}
                        href="tel:+1-416-987-3456"
                      >
                        {paynow.Phone}
                      </a>
                    </p>
                    <p style={{ margin: "0 0 4px 0", fontSize: "14px" }}>
                      Email:{" "}
                      <a
                        style={{ color: "var(--font-white-color)", textDecoration: "none" }}
                        href={"mailto:" + paynow.Email}
                      >
                        {paynow.Email}
                      </a>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {totalTokenizationGroups > 1 && (
              <div className="moneris-payment-progress-bar">
                Processing payment {currentTokenizationGroup} of {totalTokenizationGroups}
              </div>
            )}
            <button
              type="button"
              className="moneris-checkout-back-button"
              style={totalTokenizationGroups > 1 ? { top: "117px" } : undefined}
              onClick={() => {
                setShowMonerisHostedTokenizationPayment(false);
                setHostedTokenizationIframeSrc("");
                setIsMonerisIframeReady(false);
                setIsTokenizeSubmitting(false);
                setLoading(false);
                if (itemType !== 4) {
                  clearMonerisPaymentQueue();
                }
              }}
              aria-label="Go back"
            >
              &laquo; Back
            </button>

            {/* Payment Summary - Top right, symmetric to back button */}
            <div
              className="moneris-payment-summary"
              style={totalTokenizationGroups > 1 ? { top: "117px" } : undefined}
            >
              {serviceCharge ? (
                <>
                  <div style={{ fontSize: "16px", fontWeight: "bold", color: "#000000" }}>
                    {`Payment: ${calculateTotal()}`}
                  </div>
                  <div style={{ fontSize: "16px", fontWeight: "bold", color: "#000000", marginTop: "0.1rem", marginBottom: "0.1rem" }}>
                    {`Service Fee: ${calculateServiceCharges()}`}
                  </div>
                </>
              ) : null}
              <div style={{ fontSize: serviceCharge ? "16px" : "18px", fontWeight: "bold", color: "#000000" }}>
                {`Total: ${selectedRows.length > 0 ? calculateTotalAmount() : "$0.00"}`}
              </div>
            </div>

            <div
              className="moneris-checkout-modal-content"
              style={{ marginTop: totalTokenizationGroups > 1 ? "107px" : "75px" }}
            >
              <div className="moneris-checkout-container moneris-ht-payment-container">
                <p className="moneris-ht-instructions">
                  Enter your card details below and click Process Payment
                </p>
                <iframe
                  id="monerisHppTokenIframe"
                  title="Moneris Hosted Tokenization"
                  src={hostedTokenizationIframeSrc}
                  style={{ display: "block", margin: "0 auto", width: "100%", maxWidth: "420px", minHeight: "280px", border: 0 }}
                  onLoad={() => {
                    console.log("[MonerisHT] iframe loaded, ready for postMessage");
                    setIsMonerisIframeReady(true);
                  }}
                />
                <button
                  type="button"
                  className="moneris-ht-submit-button"
                  disabled={!isMonerisIframeReady || isTokenizeSubmitting}
                  onClick={() => {
                    const ctx = hostedTokenizationPayContextRef.current;
                    const iframe = document.getElementById("monerisHppTokenIframe");
                    if (!ctx || !iframe?.contentWindow) {
                      toast.error("Payment form is not ready. Please wait and try again.", {
                        position: "top-right",
                        autoClose: 3000,
                      });
                      return;
                    }
                    try {
                      console.log("[MonerisHT] sending tokenize postMessage to", ctx.postMessageTarget);
                      setIsTokenizeSubmitting(true);
                      iframe.contentWindow.postMessage("tokenize", ctx.postMessageTarget);
                    } catch (err) {
                      console.error("[MonerisHT] postMessage failed:", err);
                      setIsTokenizeSubmitting(false);
                      toast.error("Failed to communicate with payment form. Please refresh and try again.", {
                        position: "top-right",
                        autoClose: 4000,
                      });
                    }
                  }}
                >
                  {isTokenizeSubmitting ? "Processing..." : !isMonerisIframeReady ? "Loading..." : "Process Payment"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Full-screen loader for processing receipt - shows AFTER checkout closes */}
        {isProcessingReceipt && (
          <div className="moneris-processing-loader-overlay">
            <div className="api-loading-container">
              <div id="loader"></div>
              <p className="loading-text">
                {totalTokenizationGroups > 1
                  ? `Processing store ${currentTokenizationGroup} of ${totalTokenizationGroups}`
                  : "Processing payment..."}
              </p>
            </div>
          </div>
        )}


        {showCardSaveModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowCardSaveModal(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <SaveCardSection
                getCardId={getCardId}
                vaultTerms={vaultTerms}
                isCheck={isCheck}
                setIsCheck={setIsCheck}
                monerisSaveCardOptions={monerisSaveCardOptions}
                formData={formData}
                handleChange={handleChange}
                errors={errors}
                enableSaveButton={enableSaveButton}
                setShowCardSaveModal={setShowCardSaveModal}
                paymentProcessor={paymentProcessor}
                handleSaveCard={handleSaveCard}
                accName={accName}
                paynow={paynow}
                currencyCode={currencyCode}
                setLoading={setLoading}
                endpoint={endpoint}
                guid={guid}
                corpid={corpid}
                token={token}
                groupedInvoices={groupedInvoices}
                sendrespons={sendrespons}
                createCustomer={createCustomer}
                basysCustomerID={basysCustomerID}
                basysAccountInfo={basysAccountInfo}
                isBasysTesting={isBasysTesting}
                basysBillingAddrInfo={basysBillingAddrInfo}
                basysApiToken={basysApiToken}
                setCardHasBeenSaved={setCardHasBeenSaved}
                setErrors={setErrors}
                invoiceItems={invoiceItems}
                selectedRows={selectedRows}
                setFailedIsOpen={setFailedIsOpen}
                setISOpen={setISOpen}
                data={data}
                setPaymentFailureReason={setPaymentFailureReason}
                setIsCardSaveFailedOpen={setIsCardSaveFailedOpen}
                setIsCardSaveOpen={setIsCardSaveOpen}
                checkboxRef={checkboxRef}
                itemType={itemType}
                displayName={displayName}
                isMonerisTesting={isMonerisTesting}
                paymentProcessorName={paymentProcessorName.current}
                cardHasBeenSaved={cardHasBeenSaved}
                monerisStoresLinked={monerisStoresLinked}
              />
            </div>
          </div>
        )}
      </div>
      {itemType === 4 && !(showMonerisCheckout && paymentProcessor === 0) ? (
        <div className="save-card-container">
          <div className="dashboard">
            <div className="save-card-page">
              <div className="dashboard_head">
                <div className="header-logo-container">
                  <div className="logo">
                    <img
                      src={`${imageUrl}${corpid}.png`}
                      alt="logo"
                      style={{ width: "70px", marginTop: "2.5px" }} // Adjust the width and height as needed
                    />
                  </div>
                  <div className="header-title-text">{`${paynow?.Title
                    } ${getPageTitle()}`}</div>
                </div>
                <div className="contect">
                  {paynow && paynow.ShowTopBanner && (
                    <p>Need Help? {paynow.HelpCenterPhone}</p>
                  )}
                </div>
              </div>
              <SaveCardSection
                getCardId={getCardId}
                vaultTerms={vaultTerms}
                isCheck={isCheck}
                setIsCheck={setIsCheck}
                monerisSaveCardOptions={monerisSaveCardOptions}
                formData={formData}
                handleChange={handleChange}
                errors={errors}
                enableSaveButton={enableSaveButton}
                setShowCardSaveModal={setShowCardSaveModal}
                paymentProcessor={paymentProcessor}
                handleSaveCard={handleSaveCard}
                accName={accName}
                paynow={paynow}
                currencyCode={currencyCode}
                setLoading={setLoading}
                endpoint={endpoint}
                guid={guid}
                corpid={corpid}
                token={token}
                groupedInvoices={groupedInvoices}
                sendrespons={sendrespons}
                createCustomer={createCustomer}
                basysCustomerID={basysCustomerID}
                basysAccountInfo={basysAccountInfo}
                isBasysTesting={isBasysTesting}
                basysBillingAddrInfo={basysBillingAddrInfo}
                basysApiToken={basysApiToken}
                setCardHasBeenSaved={setCardHasBeenSaved}
                setErrors={setErrors}
                invoiceItems={invoiceItems}
                selectedRows={selectedRows}
                setFailedIsOpen={setFailedIsOpen}
                setISOpen={setISOpen}
                data={data}
                setPaymentFailureReason={setPaymentFailureReason}
                setIsCardSaveFailedOpen={setIsCardSaveFailedOpen}
                setIsCardSaveOpen={setIsCardSaveOpen}
                checkboxRef={checkboxRef}
                itemType={itemType}
                displayName={displayName}
                isMonerisTesting={isMonerisTesting}
                paymentProcessorName={paymentProcessorName.current}
                cardHasBeenSaved={cardHasBeenSaved}
                monerisStoresLinked={monerisStoresLinked}
              />
            </div>
            <div className="savecard-footer-container">
              {paynow && paynow.ShowBottomBanner && (
                <div className="savecard-footer">
                  <h2>{paynow.Title}</h2>
                  <p>
                    Phone:{" "}
                    <a
                      style={{
                        color: "var(--font-gray-color)",
                        textDecoration: "none",
                      }}
                      href="tel:+1-416-987-3456"
                    >
                      {paynow.Phone}
                    </a>
                  </p>
                  <p>
                    Email:{" "}
                    <a
                      style={{
                        color: "var(--font-gray-color)",
                        textDecoration: "none",
                      }}
                      href={"mailto:" + paynow.Email}
                    >
                      {paynow.Email}
                    </a>
                  </p>
                  <p>
                    Address: {paynow.Address} {paynow.City}, {paynow.Prov},{" "}
                    {paynow.Postal}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
